import { render, staticRenderFns } from "./screenInfo.vue?vue&type=template&id=ab0884ae&scoped=true"
import script from "./screenInfo.vue?vue&type=script&lang=js"
export * from "./screenInfo.vue?vue&type=script&lang=js"
import style0 from "./screenInfo.vue?vue&type=style&index=0&id=ab0884ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0884ae",
  null
  
)

export default component.exports